<div class="container-fluid">
  <div class="card">
    <div class="card-body">
      <div [hidden]="!hasRouteAccess(routes.SECURE.ACCOUNT.VIEW)" class="form-group">
        <div [hidden]="isResultListEmpty()" class="margin-top-bottom">
          <h3>
            <i class="fa fa-info-circle"></i> No request to pay transactions found. </h3>
          </div>
          <app-search-view>
            <app-payment-search #app
              (displayBatchNumber)="updateDisplayBatchNumber($event)"
              [autoRefresh]="true"
            filters></app-payment-search>
            <div class="mt-5" export>
              <button (click)="exportRequestToPays()"
                [disabled]="isGuestAdminUser()"
                class="navy-btn cursor-pointer btn-margin-bottom export-rtp-button"
                type="button">
                <p class="display-inline" id="export-request-to-pay-label">Export</p>
              </button>
              <i class="pi pi-question-circle tooltip-icon"
              pTooltip="{{getExportRequestsToPayTooltipText()}}"></i>
            </div>
            <table class="table table-hover table-responsive-md table-wrap-sm" grid>
              <div class="sort-field-md">
                <p-select (onChange)="applySorting(selectedSortField?.id, app)"
                  [(ngModel)]="selectedSortField"
                  [options]="sortFields"
                  [showClear]="true"
                  class="sort-field"
                  optionLabel="name"
                  optionValue="value"
                placeholder=" Sort by:"></p-select>
                <em (click)="applySorting(selectedSortField?.id,app)"
                class="{{ isDesc(selectedSortField?.id) ? 'fa fa-sort-desc': isAsc(selectedSortField?.id) ? 'fa fa-sort-asc':'fa fa-sort'}}"></em>
              </div>
              <thead>
                <tr>
                  <th #dateTimeCreated
                    (click)="applySorting(dateTimeCreated.id, app)"
                    class="sort-field"
                    id="dateTimeCreated"
                    scope="col">Date Created
                    <em class="{{ isDesc(dateTimeCreated.id) ? 'fa fa-sort-desc': isAsc(dateTimeCreated.id) ? 'fa fa-sort-asc':'fa fa-sort'}}"></em>
                  </th>
                  <th #accountNumber
                    (click)="applySorting(accountNumber.id, app)"
                    class="sort-field"
                    id="accountNumber"
                    scope="col">Account Number
                    <em class="{{ isDesc(accountNumber.id) ? 'fa fa-sort-desc': isAsc(accountNumber.id) ? 'fa fa-sort-asc':'fa fa-sort'}}"></em>
                  </th>
                  @if (displayBatchNumber) {
                    <th id="batchNumber" scope="col">
                      Batch Number
                    </th>
                  }
                  <th #referenceNumber
                    (click)="applySorting(referenceNumber.id, app)"
                    class="sort-field"
                    id="referenceNumber"
                    scope="col">Reference
                    <em class="{{ isDesc(referenceNumber.id) ? 'fa fa-sort-desc': isAsc(referenceNumber.id) ? 'fa fa-sort-asc':'fa fa-sort'}}"></em>
                  </th>
                  <th #customer
                    (click)="applySorting(customer.id, app)"
                    class="sort-field"
                    id="customer"
                    scope="col">Name
                    <em class="{{ isDesc(customer.id) ? 'fa fa-sort-desc': isAsc(customer.id) ? 'fa fa-sort-asc':'fa fa-sort'}}"></em>
                  </th>
                  <th #amount
                    (click)="applySorting(amount.id, app)"
                    class="sort-field"
                    id="amount"
                    scope="col">Amount
                    <em class="{{ isDesc(amount.id) ? 'fa fa-sort-desc': isAsc(amount.id) ? 'fa fa-sort-asc':'fa fa-sort'}}"></em>
                  </th>
                  <th #dateTimePaid
                    (click)="applySorting(dateTimePaid.id, app)"
                    class="sort-field"
                    id="dateTimePaid"
                    scope="col">Date Paid
                    <em class="{{ isDesc(dateTimePaid.id) ? 'fa fa-sort-desc': isAsc(dateTimePaid.id) ? 'fa fa-sort-asc':'fa fa-sort'}}"></em>
                  </th>
                  <th id="status" scope="col">Status <i class="pi pi-question-circle tooltip-icon"
                  pTooltip="{{getAccountStatusUtil().getDescriptionOfAllFormatted()}}"></i>
                </th>
                <th scope="col">Notification Status <i class="pi pi-question-circle tooltip-icon"
                pTooltip="The status of the last notification sent"></i>
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody class="table-hover text-nowrap">
            @for (account of contents; track account) {
              <tr class="cursor-pointer  active-color">
                <td (click)="view(account)">
                  <span class="p-column-title">Date Created</span>
                  {{ account.dateTimeCreated | amFromUtc | amLocal | amDateFormat: 'YYYY-MM-DD HH:mm:ss' }}
                </td>
                <td (click)="view(account)">
                  <span class="p-column-title">Account Number</span>
                  {{ account.accountNumber }}
                </td>
                @if (displayBatchNumber) {
                  <td (click)="view(account)">
                    <span class="p-column-title">Batch Number</span>
                    {{ account.batchNumber }}
                  </td>
                }
                <td (click)="view(account)">
                  <span class="p-column-title">Reference</span>
                  {{ account.referenceNumber }}
                </td>
                <td (click)="view(account)">
                  <span class="p-column-title">Name</span>
                  {{ account.customer }}
                </td>
                <td (click)="view(account)">
                  <span class="p-column-title">Amount</span>
                  {{
                  getAmount(account) | toMajor |
                  currency:'R '
                  }}
                </td>
                <td (click)="view(account)" class="account_status_col">
                  <span class="p-column-title">Date Paid</span>
                  {{ account?.dateTimePaid ? (account?.dateTimePaid | amFromUtc | amLocal | amDateFormat: 'YYYY-MM-DD HH:mm:ss') : null }}
                </td>
                <td (click)="view(account)" class="account_status_col">
                  <span class="p-column-title">Status</span>
                  <span [ngClass]="getAccountStatusUtil().getAccountTextColorClass(account.accountState)">
                    {{ account.accountState | getAccountStatusDescription }}
                  </span>
                </td>
                <td (click)="view(account)">
                  <span class="p-column-title">Notification Status</span>
                  {{ account.lastNotificationStatus | formatNotificationStatus }}
                </td>
                <hr/>
                <td #menuContainer>
                  <div #menu class="text-center">
                    <div [pTooltip]="isGuestAdminUser() ? 'Guest accounts cannot download invoices.' : null">
                      <div (click)="openMenu($event, contextMenu, account)"
                        [class.grey-circle-style]="isGuestAdminUser()"
                        class="circle-style">
                        <i class="fa fa-solid fa-ellipsis-vertical fa-lg"></i>
                      </div>
                    </div>
                    <span class="p-column-title"></span>
                  </div>
                  <p-contextMenu #contextMenu
                    [appendTo]="'body'"
                    [model]="contextMenuItems"
                    [target]="menu"
                    class="custom-contextmenu">
                    <ng-template let-item pTemplate="item">
                      <a class="flex align-items-center p-menuitem-link custom-menu-item" pRipple>
                        <i [class]="item.icon + ' menu-item-icon'"></i>
                        <span class="ml-2 menu-item-text">{{ item.label }}</span>
                      </a>
                    </ng-template>
                  </p-contextMenu>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </app-search-view>
    </div>
  </div>
</div>
</div>